import { Stack, Typography } from "@mui/material";

type Props = {
  currentBlock: any;
};

const InitialsField = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;
  const position = currentBlock?.config?.position;
  const response = currentBlock?.response;

  return (
    <Stack gap={1} direction={position === "top" ? "column-reverse" : "column"}>
      <Typography variant="subtitle1" fontWeight="regular">
        {label}
      </Typography>
      <Typography variant="body1">{response?.input || ""}</Typography>
    </Stack>
  );
};
export default InitialsField;
